/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";
import { buildFooter, useRoute } from "./common";
import { LocaleSelectorDesktop } from "./locale";
import { TrustpilotWidget } from "@/providers/trust";

import ZapptaxLogo from "@/assets/shared-zapptax-inverted.svg";
import SuccessIcon from "@/assets/shared-newsletter-success.svg";

import ZapptaxDefaultLogo from "@/assets/shared-zapptax-default.svg";
import ZapptaxRetailLogo from "@/assets/shared-logo-retailer-neg.svg";
import ZapptaxShippingLogo from "@/assets/shared-logo-shipping-neg.svg";

import SocialInstagram from "@/assets/footer-social-instagram.svg";
import SocialFacebook from "@/assets/footer-social-facebook.svg";
import SocialLinkedIn from "@/assets/footer-social-linkedin.svg";
import SocialRedNote from "@/assets/footer-social-rednote.svg";
import SocialWeChat from "@/assets/footer-social-wechat.svg";

import FlagFr from "@/assets/footer-flag-fr.svg";
import FlagBe from "@/assets/footer-flag-be.svg";
import FlagEs from "@/assets/footer-flag-es.svg";
import FlagUk from "@/assets/footer-flag-uk.svg";

import CompSpfFinances from "@/assets/footer-compliancy-spf-finances.png";
import CompAgenciaTributaria from "@/assets/footer-compliancy-agencia-tributaria.png";
import { Footer, useFooter } from "@/providers/strapi/content/types/singleTypes/footer";
import { ContactUs } from "@/providers/strapi/content/types/components/footer.component";
import ReactMarkdown from "react-markdown";
import { StrapiImage } from "@/providers/strapi";
import { Locale, locales } from "@/config";
import { ReactNode } from "react";
import clsx from "clsx";


export function FooterDesktop({
  className,
  onShowWechatQrAction,
  ...pageProps
}: X.PageProps<{
  className?: string;
  onShowWechatQrAction: () => void;
}>) {
  const route = useRoute('footerDesktop');
  const logo = (
    route[0] === "shipping" ? { image: ZapptaxShippingLogo, height: "h-16", alt: "Zapptax Shipping", to: "/shipping" as X.PageHref } :
      route[0] === "retail" ? { image: ZapptaxRetailLogo, height: "h-16", alt: "Zapptax Retail", to: "/retail" as X.PageHref } :
        { image: ZapptaxLogo, height: "h-10", alt: "Zapptax", to: "/" as X.PageHref }
  );

  const [section] = useRoute('footerDesktop');
  const isRetail = section === "retail";//|| section === "shipping";
  const contactUsRetailer = useFooter('contactUsRetailer') as Footer['contactUsRetailer']
  const contactUsTraveler = useFooter('contactUsTraveler') as Footer['contactUsTraveler']
  return (
    <footer className={X.clsx("hidden xl:block bg-black text-white py-12", className)}>
      <div className="max-w-content mx-auto px-4">

        <div className="flex justify-between mb-12">
          <LocaleSelectorDesktop
            {...pageProps}
            hoverColor="white"
          />

          <div>
            <X.Link href={logo.to} className="flex items-center">
              <X.Image
                src={logo.image}
                alt={logo.alt}
                className={`w-auto ${logo.height}`}
              // alt="Zapptax"
              // height={28}
              // className="w-auto"
              />
            </X.Link>

          </div>
        </div>

        <div className="grid grid-cols-2 gap-8">
          <div className="grid grid-cols-2 gap-8">
            <GetTheApp />
            <TrustpilotAndSocial onShowWechatQr={onShowWechatQrAction} />

            <div className="col-span-2">
              {isRetail ? <BecomePartner /> : <Newsletter locale={pageProps.locale} />}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <Contact isRetail={isRetail} onShowWechatQr={onShowWechatQrAction} contactUs={isRetail ? contactUsRetailer : contactUsTraveler} />
            <Compliance />
          </div>
        </div>


        <Sitemap {...pageProps} />
        <Legal />
      </div>
    </footer>
  );
}


function Compliance() {
  // const tr = X.useTranslator();
  const customs = useFooter('customs') as Footer['customs'];
  return (
    <div>
      {/* <h3 className="text-[18px] font-medium mb-4">
        {customs.label}
        {tr({
          en: "In compliance with regulations by",
          fr: "En conformité avec les réglementations établies par",
        })}
      </h3> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h3 {...props} className="text-[18px] text-sm mb-4" />,
        h1: ({ ...props }) => <h3 {...props} className="text-[18px] text-sm mb-4" />,
        h2: ({ ...props }) => <h3 {...props} className="text-[18px] text-sm mb-4" />,
        h3: ({ ...props }) => <h3 {...props} className="text-[18px] text-sm mb-4" />,
        h4: ({ ...props }) => <h3 {...props} className="text-[18px] text-sm mb-4" />,
        h5: ({ ...props }) => <h3 {...props} className="text-[18px] text-sm mb-4" />,
      }}>
        {customs.label}
      </ReactMarkdown>
      <div className="flex flex-row justify-between items-center space-x-4 mb-6">
        <X.ExternalLink href="http://www.agenciatributaria.es/">
          <X.Image
            src={CompAgenciaTributaria}
            alt="Agencia Tributaria"
            height={40}
          />
        </X.ExternalLink>
        <X.ExternalLink href="https://finances.belgium.be/">
          <X.Image
            src={CompSpfFinances}
            alt="SPF Finances"
            height={34}
          />
        </X.ExternalLink>
      </div>

      <div className="text-[12px]">
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} />,
          h1: ({ ...props }) => <p {...props} />,
          h2: ({ ...props }) => <p {...props} />,
          h3: ({ ...props }) => <p {...props} />,
          h4: ({ ...props }) => <p {...props} />,
          h5: ({ ...props }) => <p {...props} />,
        }}>
          {customs.info}
        </ReactMarkdown>
        {/* <p>{customs.info}</p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} />,
          h1: ({ ...props }) => <p {...props} />,
          h2: ({ ...props }) => <p {...props} />,
          h3: ({ ...props }) => <p {...props} />,
          h4: ({ ...props }) => <p {...props} />,
          h5: ({ ...props }) => <p {...props} />,
        }}>
          {customs.address}
        </ReactMarkdown>
        {/* <p>{customs.address}</p> */}
        {/* <p>
          {tr({
            en: "Zapptax is a registered trademark of ZAPPTAX SA Company ID: BE 0670 776 774",
            fr: "Zapptax est une marque déposée de ZAPPTAX SA enregistrée sous le numéro ID BE 0670 776 774",
          })}
        </p>
        <p>
          {tr({
            en: "Registered office: Rue du Boulet, 42 1000 Brussels, BELGIUM",
            fr: "Siège social: Rue du Boulet, 42 1000 BRUXELLES BELGIQUE",
          })}
        </p> */}
      </div>
    </div>
  );
}


function Contact(props: {
  onShowWechatQr: () => void;
  isRetail: boolean;
  contactUs: ContactUs;
}) {
  const tr = X.useTranslator();
  // const contactUsRetailer = useFooter('contactUsRetailer') as Footer['contactUsRetailer']
  // const phones = (
  //   props.isRetail
  //     ? [
  //       { phone: X.links.phone.retail.france, flag: FlagFr, name: tr({ en: "France", fr: "France" }) },
  //       { phone: X.links.phone.retail.spain, flag: FlagEs, name: tr({ en: "Spain", fr: "Espagne" }) },
  //       { phone: X.links.phone.retail.belgium, flag: FlagBe, name: tr({ en: "Belgium", fr: "Belgique" }) },
  //     ]
  //     : [
  //       { phone: X.links.phone.traveler.france, flag: FlagFr, name: tr({ en: "France", fr: "France" }) },
  //       { phone: X.links.phone.traveler.spain, flag: FlagEs, name: tr({ en: "Spain", fr: "Espagne" }) },
  //       { phone: X.links.phone.traveler.uk, flag: FlagUk, name: tr({ en: "UK", fr: "Royaume-Uni" }) },
  //       { phone: X.links.phone.traveler.belgium, flag: FlagBe, name: tr({ en: "Belgium", fr: "Belgique" }) },
  //     ]
  // );
  const phones = [
    {
      phone: props.contactUs.phoneFR, flag: FlagFr, name: props.contactUs.phoneFRLabel
      // tr({ en: "France", fr: "France", zh: 'France' })
    },
    {
      phone: props.contactUs.phoneES, flag: FlagEs, name: props.contactUs.phoneESLabel
      // tr({ en: "Spain", fr: "Espagne", zh: 'Espagne' })
    },
    props.isRetail === false ? {
      phone: props.contactUs.phoneUK, flag: FlagUk, name: props.contactUs.phoneUKLabel
      // tr({ en: "UK", fr: "Royaume-Uni", zh: 'UK' })
    } : null,
    {
      phone: props.contactUs.phoneBE, flag: FlagBe, name: props.contactUs.phoneBELabel
      // tr({ en: "Belgium", fr: "Belgique", zh: 'Belgium' })
    },
  ]

  return (
    <div id="footer-contact-us-desktop">
      {/* <h3 className="text-[18px] font-medium mb-4">
        {props.contactUs.label}
        {tr({
          en: "Contact Us",
          fr: "Contactez-nous"
        })}
      </h3> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h3 {...props} className="text-[18px]  mb-4" />,
        h1: ({ ...props }) => <h3 {...props} className="text-[18px]  mb-4" />,
        h2: ({ ...props }) => <h3 {...props} className="text-[18px]  mb-4" />,
        h3: ({ ...props }) => <h3 {...props} className="text-[18px]  mb-4" />,
        h4: ({ ...props }) => <h3 {...props} className="text-[18px]  mb-4" />
      }}>
        {props.contactUs.label}
      </ReactMarkdown>
      <div className="flex flex-row gap-4 justify-between">
        <div className="text-nowrap text-medium text-[16px]">
          <X.ExternalLink href={`mailto:${props.isRetail ? X.links.email.retail : X.links.email.support}`} className="block mb-2">
            {/* Email */}
            {/* {props.contactUs.email} */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <span {...props} />
            }}>
              {props.contactUs.email}
            </ReactMarkdown>
          </X.ExternalLink>
          {!props.isRetail && <div className="X-Open-Intercom block mb-2 cursor-pointer">
            {/* Live chat */}
            {/* {props.contactUs.liveChat} */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <span {...props} />
            }}>
              {props.contactUs.liveChat}
            </ReactMarkdown>
          </div>}
          <button onClick={props.onShowWechatQr} className="block cursor-pointer">
            {/* {props.contactUs.weChat} */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <span {...props} />
            }}>
              {props.contactUs.weChat}
            </ReactMarkdown>
          </button>
        </div>

        <div className="flex-grow flex flex-row justify-center">
          <div className="font-light text-[14px] flex flex-col gap-4">
            <div className="text-[16px] font-medium">
              <ReactMarkdown components={{
                p: ({ ...props }) => <p {...props} />
              }}>
                {props.contactUs.phone}
              </ReactMarkdown>
              {/* {props.contactUs.phone} */}
              {/* {tr({
                en: "Phone",
                fr: "Téléphone",
              })} */}
            </div>

            {phones.filter((p) => p !== null).map((country, i) => (
              <a key={i} href={`tel:${country.phone.replace(/\s+/g, "")}`}>
                <div className="flex items-center gap-2 font-medium">
                  <X.Image src={country.flag} height={10} alt={country.name} />
                  {/* <span>{country.name}</span> */}
                  <ReactMarkdown components={{
                    p: ({ ...props }) => <span {...props} />
                  }}>
                    {country.name}
                  </ReactMarkdown>
                </div>
                <div>
                  <ReactMarkdown >
                    {country.phone}
                  </ReactMarkdown>


                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}


function Newsletter({ locale }: { locale: Locale }) {
  // const tr = X.useTranslator();
  const form = X.useNewsletterForm(locale);

  const newsletter = useFooter('newsletter') as Footer['newsletter'];
  return (
    <div className="mt-4 max-w-[520px] gap-2 flex flex-col">
      {/* <h3 className="text-[16px] mb-2">
        {newsletter.label}
        {tr({
          en: "Stay in the loop. Subscribe to our newsletter",
          fr: "Suivez nos dernières actualités",
        })}
      </h3> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h3 {...props} className="text-[16px] mb-2" />,
        h1: ({ ...props }) => <h3 {...props} className="text-[16px] mb-2" />,
        h2: ({ ...props }) => <h3 {...props} className="text-[16px] mb-2" />,
        h3: ({ ...props }) => <h3 {...props} className="text-[16px] mb-2" />,
        h4: ({ ...props }) => <h3 {...props} className="text-[16px] mb-2" />
      }}>
        {newsletter.label}
      </ReactMarkdown>
      {form.isSent() ? (
        <div className={X.clsx(
          "flex flex-row items-center justify-center bg-[#404040] text-white p-2 rounded-[8px] w-full text-[12px] h-[52px]"
        )}>
          <X.Image src={SuccessIcon}
            // alt={tr({ en: "Success", fr: "Succès" })}
            alt={newsletter.success}
            className="w-[16px] h-auto mr-4" />
          <div className="text-[14px] font-bold text-center mr-2">
            <ReactMarkdown
              components={{
                h1: ({ ...props }) => <h2 {...props} />
              }}
            >
              {newsletter.thanks}
            </ReactMarkdown>
            {/* {tr({ en: "Thank you!", fr: `Merci${X.Nbsp}!` })} */}
          </div>
          <div className="text-[13px]">
            <ReactMarkdown>
              {newsletter.successConfirmationMessage}
            </ReactMarkdown>
            {/* {tr({
            en: "You are successfully subscribed to our newsletter",
            fr: "Nous avons bien enregistré votre inscription à notre newsletter",
          })} */}
          </div>
        </div>

      ) : (
        <form className="flex" onSubmit={form.handleSubmit}>
          <div className={X.clsx(
            "flex flex-row bg-[#404040] text-white rounded-lg w-full text-[12px] relative items-center border",
            form.hasTouchedError() ? "border-danger" : "border-transparent",
          )}>
            <input
              name="email"
              type="email"
              autoComplete="email"
              // placeholder={tr({ en: "Your email address", fr: "Votre e-mail" })}
              placeholder={newsletter.placeholder}
              className="text-white w-full text-[14px] px-4 h-[52px] rounded-lg outline-none"
              onChange={form.handleChangeEmail}
              onBlur={form.handleBlur}
              value={form.getEmail()}
              required
            />
            <X.Button
              label={newsletter.cta}
              // label={tr({ en: "Sign Up", fr: "Je m'inscris" })}
              className="px-4 py-2 whitespace-nowrap font-medium text-[14px]"
              processing={form.isSubmitting()}
              disabled={!form.canSubmit()}
              submit
            />
          </div>
        </form>
      )}
      {/* <p className="text-[10px] mt-2 text-zinc-400">

        {tr({
          en: "By entering my email address, I agree to receive information from Zapptax and confirm I have read the privacy policy.",
          fr: "En communiquant mon adresse e-mail, j'accepte de recevoir des informations de la part de Zapptax et je reconnais avoir pris connaissance de la politique de confidentialité.",
        })}
      </p> */}
      <ReactMarkdown components={{
        h1: ({ ...props }) => <p {...props} className="text-[10px] mt-2 text-zinc-400" />,
        p: ({ ...props }) => <p {...props} className="text-[10px] mt-2 text-zinc-400" />
      }}>
        {newsletter.info}
      </ReactMarkdown>
    </div>
  );
}


function BecomePartner() {
  // const tr = X.useTranslator();
  const becomePartner = useFooter('becomePartner') as Footer['becomePartner']
  return (
    <div className="py-6">
      {/* <p className="mb-4">
        {becomePartner.label}
        {tr({
          en: "Are you a retailer interested in Zapptax?",
          fr: "Vous êtes un commerçant et Zapptax vous intéresse ?",
        })}
      </p> */}
      <ReactMarkdown components={{
        h1: ({ ...props }) => <p {...props} className=" mt-2 text-zinc-400" />,
        p: ({ ...props }) => <p {...props} className=" mt-2 text-zinc-400" />
      }}>
        {becomePartner.label}
      </ReactMarkdown>
      <X.Button
        // label={tr({ en: "Become a partner", fr: "Devenir partenaire" })}
        label={becomePartner.cta}
        className="px-6 py-2 font-medium text-sm bg-white text-black rounded-md hover:bg-zinc-200 mt-4"
        href="/retail/become-partner"
      />
    </div>
  );
}


function TrustpilotAndSocial(props: {
  onShowWechatQr: () => void;
}) {
  return (
    <div>
      <div className="flex flex-col items-start -translate-x-[5px] -mt-2">
        <TrustpilotWidget height="96px" width="200px" />
      </div>

      <div className="flex space-x-4 mt-6">
        {([
          { image: SocialInstagram, link: X.links.social.instagram, name: "Instagram" },
          { image: SocialFacebook, link: X.links.social.facebook, name: "Facebook" },
          { image: SocialLinkedIn, link: X.links.social.linkedIn, name: "LinkedIn" },
          { image: SocialWeChat, link: X.links.social.weChat, name: "WeChat" },
          { image: SocialRedNote, link: X.links.social.redNote, name: "RedNote" },
        ] as const).map((social, i) => (
          social.name === "WeChat"
            ? (
              <button key={i} onClick={props.onShowWechatQr} className="cursor-pointer">
                <X.Image src={social.image} alt={social.name} height={19} className="w-auto" />
              </button>
            )
            : (
              <X.ExternalLink key={i} href={social.link}>
                <X.Image src={social.image} alt={social.name} height={19} className="w-auto" />
              </X.ExternalLink>
            )
        ))}
      </div>
    </div>
  );
}


function GetTheApp() {
  // const tr = X.useTranslator();
  const downloadZapptax = useFooter('downloadZapptax') as Footer['downloadZapptax'];
  const appStoreImage = useFooter('appStoreImage') as StrapiImage;
  const playStoreImage = useFooter('playStoreImage') as StrapiImage;



  return (
    <div>
      {/* <h3 className="text-[18px] font-medium mb-4">
        {tr({
          en: "Download Zapptax",
          fr: "Téléchargez Zapptax",
        })}
        {downloadZapptax}
      </h3> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h3 {...props} className="text-[18px] font-medium mb-4" />,
        h1: ({ ...props }) => <h3 {...props} className="text-[18px] font-medium mb-4" />,
        h2: ({ ...props }) => <h3 {...props} className="text-[18px] font-medium mb-4" />,
        h3: ({ ...props }) => <h3 {...props} className="text-[18px] font-medium mb-4" />,
        h4: ({ ...props }) => <h3 {...props} className="text-[18px] font-medium mb-4" />
      }}>
        {downloadZapptax}
      </ReactMarkdown>
      <div className="flex flex-col gap-3">
        <X.Link href="/download">
          <X.Image
            // src={tr({ en: AppStoreEn, fr: AppStoreFr, zh: AppStoreEn })}
            src={appStoreImage.url}
            width={appStoreImage.width}
            height={appStoreImage.height}
            className="h-[40px]"
            alt="Download on App Store"

            unoptimized
          />
        </X.Link>
        <X.Link href="/download">
          <X.Image
            // src={tr({ en: PlayStoreEn, fr: PlayStoreFr, zh: PlayStoreEn })}
            src={playStoreImage.url}
            width={playStoreImage.width}
            height={playStoreImage.height}
            className="h-[40px] "
            // height={playStoreImage.size}
            alt="Get it on Google Play"


            unoptimized
          />
        </X.Link>
      </div>
    </div>
  );
}


function Legal() {
  // const tr = X.useTranslator();
  const year = new Date().getFullYear();
  const privacyPolicy = useFooter('privacyPolicy') as Footer['privacyPolicy'];
  const termsAndConditions = useFooter('termsAndConditions') as Footer['termsAndConditions']
  const legal = useFooter('legal') as Footer['legal'];


  return (
    <div className="flex justify-between mt-12 pt-6 text-[10px]">
      <div className="flex space-x-6">
        <X.Link href="/terms-and-conditions">
          {/* {tr({
            en: "Terms of Use",
            fr: "Conditions Générales d'utilisation",
          })} */}
          <ReactMarkdown>
            {termsAndConditions}
          </ReactMarkdown>
        </X.Link>
        <X.Link href="/privacy-policy">
          <ReactMarkdown>
            {privacyPolicy}
          </ReactMarkdown>
          {/* {tr({
            en: "Privacy Policy",
            fr: "Politique de confidentialité",
          })} */}
        </X.Link>
      </div>
      <div className="font-medium">
        <ReactMarkdown>
          {legal.replace('${year}', year.toString())}
        </ReactMarkdown>
        {/* {tr({
          en: `© Copyright 2017-${year}, Zapptax S.A. All rights reserved.`,
          fr: `© Copyright 2017-${year}, Zapptax S.A. Tous droits réservés.`,
          zh: `© Copyright 2017-${year}, Zapptax S.A. All rights reserved.`,
        })} */}
        { }
      </div>
    </div>
  );
}


function Sitemap(props: X.PageProps) {
  // const tr = X.useTranslator(props);
  const footer = useFooter() as Footer;
  const menu = buildFooter(footer)
  return (
    <div className="grid grid-cols-4 gap-8 mt-12">
      {Object.entries(menu).filter(([_, s]) => s.showFooter).map(([name, section]) => {
        return (
          <div key={name}>
            <h3 className={clsx(["text-[18px]",
              // "font-medium", HANDLE BY STAPI
              "mb-4 hover:text-surface-gray-darker hover:translate-x-1 transition-transform transform-gpu"])}>
              <X.Link href={section.href}>
                {/* {tr(section.label)} */}
                <ReactMarkdown components={{
                  p: ({ ...props }) => <span {...props} />,
                  h1: ({ ...props }) => <span {...props} />,
                  h2: ({ ...props }) => <span {...props} />,
                  h3: ({ ...props }) => <span {...props} />,
                  h4: ({ ...props }) => <span {...props} />,
                  h5: ({ ...props }) => <span {...props} />
                }}>
                  {section.label}

                </ReactMarkdown>
              </X.Link>
            </h3>
            <ul className="space-y-3">
              {Object.entries(section.sub).filter(([_, sub]) => sub.type !== "button" && sub.type !== "large").map(([key, sub]) => {
                return (
                  <li key={key}>
                    <X.Link
                      key={key}
                      href={sub.href}
                      className={X.clsx("block text-[14px] text-surface-gray-darker hover:text-white hover:translate-x-1 transition-transform transform-gpu", sub.type === "large" ? "font-bold [&_*]:font-bold" : "font-normal [&_*]:font-normal")}
                    >
                      {/* {tr(sub.label)} */}
                      <ReactMarkdown>
                        {sub.label}
                      </ReactMarkdown>
                    </X.Link>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
